module.exports = __webpack_public_path__ + "img/vet.0338eb05.svg";